import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageSelectorComponent } from '../../shared/language-selector/language-selector.component';
import { FooterComponent, DonationOrgInfo } from '../../shared/footer/footer.component';
import flatpickr from 'flatpickr';
import { Instance } from 'flatpickr/dist/types/instance';

export { DonationOrgInfo } from '../../shared/footer/footer.component';

@Component({
    selector: 'don-thank-you',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        TranslateModule,
        LanguageSelectorComponent,
        FooterComponent,
    ],
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnDestroy {
  private flatpickrInstance?: Instance;

  @ViewChild('dateInput')
  set dateInput(input: ElementRef<HTMLInputElement> | undefined) {
    if (!input || this.flatpickrInstance) {
      return;
    }
 
    this.flatpickrInstance = this.flatpickrInstance = flatpickr(input.nativeElement, {
      minDate: this.todayDate,
      dateFormat: 'Y-m-d',
      disableMobile: true,
      allowInput: false,
      clickOpens: true,

      static: false,
      appendTo: document.body,
      position: 'above',

      defaultDate:
        this.monthlyJoinForm?.get('firstPaymentDate')?.value || undefined,

      onChange: (_, dateStr) => {
        this.monthlyJoinForm.get('firstPaymentDate')?.setValue(dateStr);
      },
    });
  }

  todayDate = this.getTodayDate();

  @Input() open = true;

  @Input() title = 'CAMPAIGN.ThankYouMessage';

  @Input() communityTitle = 'CAMPAIGN.BecomePartOfCommunity';
  @Input() subtitle = 'CAMPAIGN.MonthlyDonorsMakeADifference';
  @Input() descriptionLines: string[] = [
    'CAMPAIGN.JoinTheCommunity',
    'CAMPAIGN.YoureNotJustGiving',
  ];

  @Input() showMonthlyCta = true;
  @Input() monthlyCtaLabel = 'CAMPAIGN.JoinMonthlyGiving';
  @Input() ctaDisabled = false;

  @Input() org: DonationOrgInfo = {
    legalName: 'Crezco Foundation Inc',
    ein: '921100986',
    email: 'info@crezcofoundation.org',
    verified: true,
  };

  /**
   * Presentational only.
   * Source of truth lives in parent container.
   */
  @Input({ required: true }) monthlyJoinForm!: FormGroup;

  @Output() close = new EventEmitter<void>();
  @Output() joinMonthly = new EventEmitter<void>();

  constructor(private translate: TranslateService) { }

  ngOnDestroy(): void {
    this.flatpickrInstance?.destroy();
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

  onJoinMonthlyClick(): void {
    if (this.ctaDisabled || this.monthlyJoinForm.invalid) {
      this.monthlyJoinForm.markAllAsTouched();
      return;
    }

    this.joinMonthly.emit();
  }

  private getTodayDate(): string {
    const today = new Date();

    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
}